import { useRoutes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { MatxTheme } from "./components";
import SettingsProvider from "./core/contexts/SettingsContext";
import routes from "./routes";
import { useEffect, useState } from "react";
import { getAllinfo } from "./services/AllInfo";
import { PermisosProvider } from "./contexts/PermisosContext";
import AuthLoader from "./AuthLoader";

function AuthenticatedApp({ children }) {
	const [allInfo, setAllInfo] = useState(undefined);

	useEffect(() => {
		const fetchUsuario = async () => {
			try {
				const response = await getAllinfo({ desc_sistema: "pusher" });
				if (response.ok && response.data) {
					const userData = response.data.datos_usuario;
					if (userData) {
						localStorage.setItem("Usuario", userData.username);
						localStorage.setItem("emailUsuario", userData.email);
						localStorage.setItem("nombreUsuario", userData.nombre);
						localStorage.setItem("apellidoUsuario", userData.apellido);
						if (userData.foto_perfil) {
							localStorage.setItem("fotoUsuario", userData.foto_perfil);
						}
					}
					setAllInfo(response.data);
				} else {
					setAllInfo(null);
				}
			} catch (error) {
				console.error("Error al obtener datos del usuario:", error);
				setAllInfo(null);
			}
		};

		fetchUsuario();
	}, []);

	return (
		<SettingsProvider>
			<PermisosProvider allInfo={allInfo}>
				<MatxTheme>
					<CssBaseline />
					{children}
				</MatxTheme>
			</PermisosProvider>
		</SettingsProvider>
	);
}

export default function App() {
	const content = useRoutes(routes);

	return (
		<AuthLoader>
			<AuthenticatedApp>{content}</AuthenticatedApp>
		</AuthLoader>
	);
}
